import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" caret.
export const ChevronDown = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M3.58735 5.6L7.21034 9.13205L7.99401 9.89605L8.77768 9.13205L12.3886 5.6L13.4858 6.65785L7.99401 12L2.51432 6.65785L3.58735 5.6Z"
      fill="currentColor"
    />
  </svg>
);
